import React, { useState } from "react";
import _ from "lodash";
import ReactResizeDetector from "react-resize-detector";
import { useHistory } from "react-router";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsSocailListObj } from '../../analytics/analyticsObject';
const RecentTopics = ({ recentTopics }) => {
  const history = useHistory();
  const [show, setShow] = useState(true);
  const [domHeight, setDomHeight] = useState(0);
  const [recentTopicsList, setRecentTopicsList] = useState(recentTopics);

  const filterByTopic = key => {
    history.push(`/home#${key}`);
  };

  const topics = recentTopicsList || [];
  const onResize = (width, height) => {
    setDomHeight(height);
  };
  const adobeCustomLog = (item) => {
    let contEventObj = getAdobeAnalyticsEventObject(
      "search-filter",
      "search-filter",
    );
    let contObj = getAdobeAnalyticsSocailListObj({
      search: {
        searchFilter: item.name
      }
    });
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let url = '/home#' + item.id
    let customLObj = getAdobeAnalyticsCustomLinkObj(item.name, "standardplus_recentlyviewedtopics", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      onContClickData: { ...contEventObj, ...contObj },
      // pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div
      className={`bg-white rounded border border-gray-400 w-full lg:w-1/2 my-4 md:my-10 mr-3 px-8 py-6 ${!show ? "collapsed" : ""
        }`} adoberegion="standardplus_recentlyviewedtopics"
    >
      <div
        className="flex justify-between cursor-pointer"
        onClick={() => setShow(!show)}
      >
        <h3 className="text-lg text-center text-gray-800 font-normal pb-4 title-font">
          Recently viewed topics
        </h3>

        <div>
          <i
            className="fas fa-chevron-down"
            style={{
              transform: !show ? "rotate(-90deg)" : "",
              transition: "all .3s ease"
            }}
          />
        </div>
      </div>

      <div
        style={{
          maxHeight: show ? domHeight + "px" : "0",
          transition: "all .2s ease-out"
        }}
        className="overflow-hidden"
      >
        <div>
          {topics.length > 0 ? (
            <div className="flex flex-wrap">
              {topics.map(topic => (
                <div
                  key={topic.id}
                  className="w-full sm:w-1/2 mt-2 p-2 text-center"
                >
                  <div
                    onClick={() => { filterByTopic(topic.id); adobeCustomLog(topic) }}
                    className="bg-white border border-blue-600 p-2 cursor-pointer"
                    style={{ wordWrap: "break-word" }}
                  >
                    {topic.name}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <p className="text-center italic text-gray-600 p-10 title-font">
                There is no topic viewed yet.
              </p>
            </div>
          )}
          <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
      </div>
    </div>
  );
};

export default RecentTopics;
